import React from 'react'
import * as yup from "yup";

export const formSchema = yup.object().shape({
    appId: yup.number().required('Required field'),
    machineId: yup.string().required('Machine ID is a required field')
});